import React, { useState } from "react";
import Button from "shared/Button";
import { useSelector } from "react-redux";
import Loading from "shared/Loading";
import Separator from "shared/Separator";
import PaymentMethod from "shared/PaymentMethod";
import AddNewPaymentMethodModal from "shared/modals/AddNewPaymentMethodModal";
import styles from "./PaymentMethods.module.scss";

const PaymentMethods = () => {
  const [modal, setModal] = useState(null);
  const { paymentMethods } = useSelector((s) => s.account);

  if (!paymentMethods) {
    return <Loading />;
  }

  return (
    <>
      {paymentMethods.length === 0 ? (
        <EmptyPaymentMethodState />
      ) : (
        <div className={styles.savedMethods}>
          <p className={styles.heading}>Saved payment methods</p>
          {paymentMethods.map((paymentMethod) => (
            <div key={paymentMethod.id}>
              <PaymentMethod
                paymentMethod={paymentMethod}
                hasPadding
                allowDelete
                allowEdit
              />
              <Separator className={styles.separator} />
            </div>
          ))}
        </div>
      )}
      <Button
        size="md"
        className={styles.addButton}
        onClick={() => setModal(true)}
      >
        Add new payment method
      </Button>
      <AddNewPaymentMethodModal
        isOpen={modal}
        handleClose={() => setModal(false)}
      />
    </>
  );
};

export default PaymentMethods;

const EmptyPaymentMethodState = () => (
  <div>
    <p className={styles.heading}>Saved cards</p>
    <p className={styles.description}>
      You don’t currently have any saved cards. Would you like to add one now?
      This will make purchasing in the future quicker, and easier for you!
    </p>
  </div>
);
